import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import { routeTree } from './routeTree.gen';
import { queryClient } from './lib/query-client';
import './styles/globals.css';

// PROMPT 06: app é servido em /pep-vida/ via nginx.
// Usamos path prefix direto nos routes (ver arquivos em src/routes/*).
// NÃO usamos basepath pq tem comportamento inconsistente com file-based routing.
const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: ({ error, reset }) => (
    <div className="flex min-h-screen items-center justify-center bg-[#f7f5fb] p-6 text-[#29233d]">
      <div className="w-full max-w-lg rounded-xl border border-[#e5e0f0] bg-white p-6 shadow-sm">
        <h1 className="text-lg font-semibold">Não foi possível carregar esta tela</h1>
        <p className="mt-2 text-sm text-[#756f86]">
          A sessão ou os dados da consulta podem ter sido atualizados. Tente recarregar.
        </p>
        <div className="mt-4 flex gap-2">
          <button type="button" className="rounded-md bg-[#8652d0] px-4 py-2 text-sm font-medium text-white" onClick={() => { reset(); window.location.reload(); }}>
            Recarregar
          </button>
          <button type="button" className="rounded-md border border-[#e5e0f0] px-4 py-2 text-sm" onClick={() => console.error(error)}>
            Ver erro no console
          </button>
        </div>
      </div>
    </div>
  ),
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
